import { render, staticRenderFns } from "./yhsList.vue?vue&type=template&id=e5217600&scoped=true&"
import script from "./yhsList.vue?vue&type=script&lang=js&"
export * from "./yhsList.vue?vue&type=script&lang=js&"
import style0 from "./yhsList.vue?vue&type=style&index=0&id=e5217600&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5217600",
  null
  
)

export default component.exports